// extracted by mini-css-extract-plugin
module.exports = {"header":"finances_header__Mxg0X","table":"finances_table__29IvX","section":"finances_section__31aqP","sectionTitle":"finances_sectionTitle__2SltS"};